import uuidv4 from 'uuid-browser/v4';
import { defaultOccupant, defaultPhotoID } from '../../../types';
import { saveApplication, debounce } from '../../../utilities';
import { DEBOUNCE_TIME } from '../../../constants';
import validate from '../../../validations';
import { isAdult } from 'utils';

export default {
  refreshOn: ({ occupants }) => [occupants],
  init: (fullState, stateManager, internalStateSetter) => {
    debounce(() => saveApplication(stateManager), DEBOUNCE_TIME);
  },
  'Occupants.Wrapper.OccupantList': ({ occupants, removedOccupantID: id, updatedOccupantID, action }, stateManager) => {
    const { employmentInformations, photoIDs } = stateManager.store.getState();
    const filteredEmployee = employmentInformations.filter((person) => person.id !== id);
    const filteredOccupants = occupants.filter((person) => person.id !== id);
    stateManager.setOccupants(filteredOccupants);
    stateManager.setEmploymentInformations(filteredEmployee);


    const adultOccupants = filteredOccupants.filter((person) => isAdult(person.dob));
    let updatedphotoIDs = adultOccupants.map(adult => {
      const photo = photoIDs.find(photo => photo.type === `photoID-${adult.id}`)
      if (!photo) {
        return{ ...defaultPhotoID, type: `photoID-${adult.id}`, id: `photoID-${adult.id}` }
      } else { return photo }
    })

    updatedphotoIDs = updatedphotoIDs.filter((photo) => {
      return !!(adultOccupants.find(adult => photo.type === `photoID-${adult.id}`))
    })

    stateManager.setPhotoIDs(updatedphotoIDs);
    validate(3000);
  },
  'Occupants.Wrapper.AddOccupant': ({ occupants }, stateManager) => {
    const newOccupant = { ...defaultOccupant };
    newOccupant.id = uuidv4();
    newOccupant.status = 'occupant';

    stateManager.setOccupants([...occupants, newOccupant]);
    debounce(() => saveApplication(stateManager), DEBOUNCE_TIME);
  }
};
